export default class StickyHeader {
    constructor() {
        this.lastScrollTop = 0;
        this.init();
    }

    scrollHandler() {
        let scrollTop = document.documentElement.scrollTop;

        if ( document.body.classList.contains( 'disable-sticky-header' ) ) {
            return;
        }

        if ( scrollTop > 0 ) {
            document.body.classList.add( 'enable-sticky-header' );
        } else {
            document.body.classList.remove( 'enable-sticky-header' );
        }

        if ( scrollTop > this.lastScrollTop ){
            document.body.classList.remove( 'up-sticky-header' );
            document.body.classList.add( 'down-sticky-header' );
        } else {
            document.body.classList.remove( 'down-sticky-header' );
            document.body.classList.add( 'up-sticky-header' );
        }

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    init() {
        if ( document.body.classList.contains( 'hide-sticky-header' ) ) {
            return;
        }

        window.addEventListener( 'scroll', this.scrollHandler );
    }
}